import { formatOverallScore } from '../../shared/scoreDisplay.js';
import { formatDateDDMonYYYY } from '../../utils/dates.js';
import { ScrollX } from './ScrollX.jsx';
import { verdictClass } from '../utils/severity.js';

/**
 * RecentReportsTable — consumption of /api/reports/recent. Used by all three
 * tier dashboards.
 */
export function RecentReportsTable({ reports, navigate, emptyHint }) {
  if (!reports || reports.length === 0) {
    return (
      <p className="recent-reports-empty">
        {emptyHint || 'No reports yet — upload an .xer file to see your first schedule analysis here.'}
      </p>
    );
  }
  return (
    /* MOBILE-FIT M2 (v3.34): the wrapper already scrolled horizontally —
       ScrollX adds the whitelist marker + the measured right-edge fade. */
    <ScrollX className="responsive-table">
      <table className="recent-reports-table">
        <thead>
          <tr>
            <th>Project</th>
            <th>Verdict</th>
            <th>Score</th>
            <th>Created</th>
            <th aria-label="Open"></th>
          </tr>
        </thead>
        <tbody>
          {reports.map((r) => (
            <tr key={r.id}>
              <td>{r.project_name}</td>
              <td>
                {/* F3 (Rule 12): shared verdict → severity colour; text is the
                    stored verdict verbatim. */}
                <span className={`verdict-chip verdict-${verdictClass(r.verdict_status)}`}>
                  {r.verdict_status || '—'}
                </span>
              </td>
              {/* FIX-B Part 3: the ONE display score — same rounded integer
                  as the report page ring and the PDF cover (never 71.2). */}
              <td>{formatOverallScore(r.overall_score)}</td>
              <td>{formatDate(r.created_at)}</td>
              <td>
                <a
                  href={`/reports/${r.id}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/reports/${r.id}`); }}
                >Open</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </ScrollX>
  );
}

// A1 (D-ListDateFormat): every user-facing date routes through the one shared
// DD Mon YYYY formatter (utils/dates.js) — no locale-dependent variants.
function formatDate(iso) {
  return formatDateDDMonYYYY(iso);
}
